// extracted by mini-css-extract-plugin
module.exports = {"name":"Name_name__38zhV","dark":"Name_dark__23OZ9"};